import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
//
import MenuTable from './MenuTable';
//
import Loader from 'src/components/Loader';
import { getFaqsContent } from 'src/api/api';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export default function FaqsMenuTabs() {
  const [value, setValue] = useState(0);

  const [loading, setLoading] = useState(false);
  const [faqs, setFaqs] = useState([]);

  // Change Menu Values
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Get ALL Faqs
  useEffect(() => {
    setLoading(true);
    const promise = getFaqsContent();
    Promise.resolve(promise).then((data) => {
      if (data.success) {
        const content = data?.data;
        if (data) {
          setFaqs(content);
        }
        setLoading(false);
      } else {
        setFaqs([]);
        setLoading(false);
      }
    });
  }, []);

  return (
    <>
      {loading && <Loader />}
      {!loading && (
        <Box sx={{ mt: 2 }}>
          <Box sx={{ width: '100%' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              aria-label="visible arrows tabs example"
              sx={{
                [`& .${tabsClasses.scrollButtons}`]: {
                  '&.Mui-disabled': { opacity: '0.3' }
                }
              }}
            >
              {faqs?.map((item, index) => {
                if (!item.faqsContent == '')
                  return <Tab label={item?.countryName} {...a11yProps(index)} key={index} />;
              })}
            </Tabs>
          </Box>

          {faqs?.map((item, index) => {
            if (item.countrySlug)
              return (
                <TabPanel value={value} index={index} key={index} id={index}>
                  <Box sx={{ borderRadius: 1, border: '1px solid #929eaa6b' }}>
                    <MenuTable data={item} menuId={item.countrySlug} />
                  </Box>
                </TabPanel>
              );
          })}
        </Box>
      )}
    </>
  );
}
